import {
    FETCH_PIANOTECHUSER_LIST_STARTED,
    FETCH_PIANOTECHUSER_LIST_SUCCEEDED,
    FETCH_PIANOTECHUSER_LIST_FAILED,
    FIND_PIANOTECHUSER_STARTED,
    FIND_PIANOTECHUSER_SUCCEEDED,
    FIND_PIANOTECHUSER_FAILED,
    SAVE_PIANOTECHUSER_STARTED,
    SAVE_PIANOTECHUSER_SUCCEEDED,
    SAVE_PIANOTECHUSER_FAILED,
    RETURN_TO_PIANOTECHUSER_LIST,
    SWITCH_EDIT_TYPE,
    PIANOTECHUSER_MODIFIED,
    PIANOTECHUSER_VALIDATE,
} from '../actions/PianoTechUserActions';
import {
    MESSAGE_TYPE_CONFIRM,
    MESSAGE_TYPE_ERROR,
    MESSAGE_TYPE_INFO,
    VIEW_PIANOTECHUSER_LIST,
    VIEW_PIANOTECHUSER_UPDATE,
    MAINTENANCE_TYPE_COMPLETE,
} from '../app-constants';

const initialState = {
    pianotechuserList: [],
    pianotechuser: null,
    originalPianoTechUser: null,
    view: VIEW_PIANOTECHUSER_LIST,
};
const reducerOutput = (state = initialState, action) => {

    switch (action.type) {
        case FETCH_PIANOTECHUSER_LIST_STARTED:

            return {
                ...state,
                message: 'Retrieving PianoTechUser list.',
                messageType: MESSAGE_TYPE_INFO,
                pianoTechUserList: [],
            }

        case FETCH_PIANOTECHUSER_LIST_SUCCEEDED:

            return {
                ...state,
                pianoTechUserList: action.pianoTechUserList,
                message: 'PianoTechUser list successfully retrieved.',
                messageType: MESSAGE_TYPE_INFO,
            }

        case FETCH_PIANOTECHUSER_LIST_FAILED:

            return {
                ...state,
                pianoTechUserList: [],
                message: 'Error trying to retrieve PianoTechUser list.',
                messageType: MESSAGE_TYPE_ERROR,
            }

        case RETURN_TO_PIANOTECHUSER_LIST:

            return {
                ...state,
                pianoTechUser: null,
                originalPianoTechUser: null,
                message: '',
                view: VIEW_PIANOTECHUSER_LIST
            }

        case SWITCH_EDIT_TYPE:

            return {
                ...state,
                maintenanceType: action.maintenanceType,
                title: action.title,
                message: '',
                pianoTechUser: action.pianoTechUser,
            }

        case FIND_PIANOTECHUSER_STARTED:

            return {
                ...state,
                message: 'Retrieving PianoTechUser.',
                messageType: MESSAGE_TYPE_INFO,
                pianoTechUser: null,
                maintenanceType: action.maintenanceType,
                title: action.title,
            }

        case FIND_PIANOTECHUSER_SUCCEEDED:

            return {
                ...state,
                pianoTechUser: action.pianoTechUser,
                originalPianoTechUser: action.originalPianoTechUser,
                message: 'PianoTechUser successfully retrieved.',
                messageType: MESSAGE_TYPE_INFO,
                view: VIEW_PIANOTECHUSER_UPDATE,
            }

        case FIND_PIANOTECHUSER_FAILED:

            return {
                ...state,
                pianoTechUser: null,
                message: 'Error trying to find PianoTechUser.',
                messageType: MESSAGE_TYPE_ERROR,
            }

        case PIANOTECHUSER_MODIFIED:

            return {
                ...state,
                pianoTechUser: action.pianoTechUser,
                message: '',
            }

        case SAVE_PIANOTECHUSER_STARTED:

            return {
                ...state,
                message: action.message,
                messageType: MESSAGE_TYPE_INFO,
            }

        case SAVE_PIANOTECHUSER_SUCCEEDED:

            return {
                ...state,
                pianoTechUser: action.pianoTechUser,
                message: action.message,
                messageType: MESSAGE_TYPE_CONFIRM,
                maintenanceType: MAINTENANCE_TYPE_COMPLETE,
            }

        case SAVE_PIANOTECHUSER_FAILED:

            return {
                ...state,
                message: action.message,
                messageType: MESSAGE_TYPE_ERROR,
            }

        case PIANOTECHUSER_VALIDATE:

            return {
                ...state,
                message: action.message,
                messageType: action.messageType,
            }

        default:
            return state;
    }
}


export default reducerOutput;
